<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="approval-main">
      <!-- <el-collapse v-model="collapseActiveName" accordion>
        <el-collapse-item name="1"> -->
          <!-- <template slot="title">
            <el-badge :value="pendingApprovalTotal" class="item"><i class="el-icon-damai-hetong"></i>合同审批123</el-badge>
          </template> -->
          <div>
            <el-tabs v-model="activeName"  type="card">
              <el-tab-pane label="待我审批" name="pendingApproval">
                <table-main :tableHeight="520" :selection="false" :tableHead="pendingApprovalTableHead" @seeExample="seeExample" :tableData="pendingApprovalTableData" :operationArr="pendingApprovalOperationArr" @toDetailsPage="toDetailsPage" :total="pendingApprovalTotal" :pageNum="pendingApprovalPageNum" :pageSize="pendingApprovalPageSize"    @changePagination="changePendingApprovalPagination" />
              </el-tab-pane>
              <el-tab-pane label="我已审批" name="approved">
                <table-main :tableHeight="520" :selection="false" :tableHead="approvedTableHead" @seeExample="seeExample" :tableData="approvedTableData" :operationArr="approvedOperationArr" @toDetailsPage="toDetailsPage"    :total="approvedTotal" :pageNum="approvedPageNum" :pageSize="approvedPageSize" @changePagination="changeApprovedPagination" />
              </el-tab-pane>
              <el-tab-pane label="我发起的" name="sponsored">
                <table-main :tableHeight="520" :selection="false" :tableHead="sponsoredTableHead" @seeExample="seeExample" :tableData="sponsoredTableData" :operationArr="sponsoredOperationArr" @toDetailsPage="toDetailsPage"    :total="sponsoredTotal" :pageNum="sponsoredPageNum" :pageSize="sponsoredPageSize" @changePagination="changeSponsoredPagination" />
              </el-tab-pane>
            </el-tabs>
          </div>
        <!-- </el-collapse-item>
      </el-collapse> -->
    </div>

    <el-dialog title="审批进度" :visible.sync="flowDialog" style="margin-top:200px">
      <approval-flow-dialog :apply="applyData" :chain="chain" :flow="flowData"></approval-flow-dialog>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TableMain from "../../../components/Table/TableMain";
import { errorHandler } from "../../../utils/errorHandler";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import { api } from "../../api/WorkbenchApproval";
import ApprovalFlowDialog from "../components/approvalFlowDialog";

export default {
  components: {
    TableMain,
    Breadcrumb,
    ApprovalFlowDialog,
  },
  name: "workbench-approval",
  data() {
    return {
      yqCode: "",
      breadcrumb: [
        {
          value: "待办事项",
          name: "contract-approval",
        },
        {
          value: "合同审批",
        },
      ],
      collapseActiveName: "",
      contractCollapseItemTitle: "合同审批",
      accountCode: "",
      activeName: "pendingApproval",

      // 我发起的
      sponsoredTableHead: [
        {
          prop: "auditType",
          label: "审核类型",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "handlePeople",
          label: "处理人",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      sponsoredTableData: [],
      sponsoredOperationArr: ["details"],
      sponsoredTotal: 0,
      sponsoredPageNum: 1,
      sponsoredPageSize: 10,

      // 待我审批
      pendingApprovalTableHead: [
        {
          prop: "auditType",
          label: "审核类型",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      pendingApprovalTableData: [],
      pendingApprovalOperationArr: ["details"],
      pendingApprovalTotal: 0,
      pendingApprovalPageNum: 1,
      pendingApprovalPageSize: 10,

      // 我已审批
      approvedTableHead: [
        {
          prop: "auditType",
          label: "审核类型",
        },
        {
          prop: "sponsorAccountName",
          label: "提交人",
        },
        {
          prop: "digest",
          label: "摘要",
        },
        {
          prop: "sponsorDate",
          label: "发起时间",
        },
        {
          prop: "workState",
          label: "状态",
          showColor: true,
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      approvedTableData: [],
      approvedOperationArr: ["details"],
      approvedTotal: 0,
      approvedPageNum: 1,
      approvedPageSize: 10,

      electricApproveData: {},
      electricUnApproveData: {},
      approveDialog: false,
      approveMemo: "",
      approveRejectDialog: false,
      rejectMemo: "",

      // 投诉建议
      tableHead: [
        {
          prop: "personName",
          label: "人员姓名",
        },
        {
          prop: "personPhone",
          label: "手机号",
        },
        {
          prop: "roomNumber",
          label: "房间号",
        },
        {
          prop: "enterpriseName",
          label: "住户名称",
        },
        {
          prop: "type",
          label: "类型",
        },
        {
          prop: "createTime",
          label: "提交时间",
        },
        {
          prop: "statusText",
          label: "状态",
        },
          {
            prop: "payChannelText",
            label: "审批进度",
            example: true
          },
      ],
      operationArr: ["modifySuggestions"],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        responsiblePersonCode: "",
        searchKey: "",
        result: "",
        status: "0",
      },

      flowDialog:false,
      applyData:{},
      chain:[],
      chainList:[],
      flowData:{},
      currentRate:0
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.requestData.responsiblePersonCode = bus.global.accountCode;
    this.accountCode = bus.global.accountCode;
    this.getPendingApprovalPage();
  },
  mounted() {
    if (this.$route.params.workType) {
      this.activeName = this.$route.params.workType;
    }
  },
  methods: {
    // 跳转审批详情页面
    toDetailsPage(data) {
      sessionStorage.setItem("workDetailData", JSON.stringify(data));
      sessionStorage.setItem("workDetailActiveName", this.activeName);
      if (data.type === "其他合同") {
        this.$router.push({
          name: "other-approval-detail",
        });
      } else {
        this.$router.push({
          name: "approval-detail",
        });
      }
    },

    // 我发起的页码跳转
    changeSponsoredPagination(data) {
      this.sponsoredPageNum = data[0];
      this.sponsoredPageSize = data[1];
      this.getPageBySponsorAccountCode();
    },

    // 待我审批页码跳转
    changePendingApprovalPagination(data) {
      this.pendingApprovalPageNum = data[0];
      this.pendingApprovalPageSize = data[1];
      this.getPendingApprovalPage();
    },

    // 我已审批页码跳转
    changeApprovedPagination(data) {
      this.approvedPageNum = data[0];
      this.approvedPageSize = data[1];
      this.getApprovedPage();
    },

    // 我发起的
    getPageBySponsorAccountCode() {
      let reqData = {};
      reqData.pageNum = this.sponsoredPageNum;
      reqData.pageSize = this.sponsoredPageSize;
      reqData.sponsorAccountCode = this.accountCode;
      this.$axios
        .post(api.getPageBySponsorAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              let length = v.contractApproveChainStatuses.length - 1;
              if (
                v.contractApproveChainStatuses[length].approveStatus === "0"
              ) {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (
                  v.contractApproveChainStatuses[length].approveResult === "1"
                ) {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === "2"
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === "3"
                ) {
                  v.workState = "审批加签";
                }
              }
              if (v.approveType === "4") {
                v.auditType = "新建合同";
              } else if (v.approveType === "5") {
                v.auditType = "续租合同";
              } else if (v.approveType === "6") {
                v.auditType = "退租合同";
              } else if (v.approveType === "15") {
                v.auditType = "作废合同";
              } else if (v.approveType === "17") {
                v.auditType = "换租合同";
              }
              v.handlePeople =
                v.contractApproveChainStatuses[length].approveAccountName;
            });
            this.sponsoredTotal = res.data.data.total;
            this.sponsoredTableData = data;
          }
        })
        .catch(errorHandler("获取我发起的审批数据失败"));
    },

    // 待我审批
    getPendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = this.pendingApprovalPageNum;
      reqData.pageSize = this.pendingApprovalPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "0";
      this.$axios.post(api.getPageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.approveType === "4") {
                v.auditType = "新建合同";
              } else if (v.approveType === "5") {
                v.auditType = "续租合同";
              } else if (v.approveType === "6") {
                v.auditType = "退租合同";
              } else if (v.approveType === "15") {
                v.auditType = "作废合同";
              } else if (v.approveType === "17") {
                v.auditType = "换租合同";
              }
            });
            this.pendingApprovalTotal = res.data.data.total;
            this.pendingApprovalTableData = data;
          }
        })
        .catch(errorHandler("获取待我审批数据失败"));
    },

    // 我已审批
    getApprovedPage() {
      let reqData = {};
      reqData.pageNum = this.approvedPageNum;
      reqData.pageSize = this.approvedPageSize;
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "1";
      this.$axios
        .post(api.getPageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (
                v.contractApproveChainStatuses[length].approveStatus === "0"
              ) {
                v.workState = "审批中";
                v.fontColorToPeople = "#FF9933";
              } else {
                if (
                  v.contractApproveChainStatuses[length].approveResult === "1"
                ) {
                  v.workState = "审批通过";
                  v.fontColorToPeople = "#00A0E6";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === "2"
                ) {
                  v.workState = "审批驳回";
                  v.fontColorToPeople = "#B22222";
                } else if (
                  v.contractApproveChainStatuses[length].approveResult === "3"
                ) {
                  v.workState = "审批加签";
                }
              }
              if (v.approveType === "4") {
                v.auditType = "新建合同";
              } else if (v.approveType === "5") {
                v.auditType = "续租合同";
              } else if (v.approveType === "6") {
                v.auditType = "退租合同";
              } else if (v.approveType === "15") {
                v.auditType = "作废合同";
              } else if (v.approveType === "17") {
                v.auditType = "换租合同";
              }
            });
            this.approvedTotal = res.data.data.total;
            this.approvedTableData = data;
          }
        })
        .catch(errorHandler("获取我已审批数据失败"));
    },

    seeExample(data){
      this.$axios.post(api.getContractApproveFlow, {code: data.code}).then(res=>{
        this.applyData=res.data.data.approveChain
        this.chain = res.data.data.statusList || []
        this.flowData = (res.data.data.flow && res.data.data.flow.flowDetails) || []
        if(this.applyData.status && this.applyData.status=='4'){
          this.flowDialog=true;
          this.currentRate=0
          return;
        }
        this.flowDialog=true
      }).catch(errorHandler("获取审批进度失败"))
    },
  },
  watch: {
    activeName(val) {
      if (val === "sponsored") {
        this.sponsoredPageNum = 1;
        this.sponsoredPageSize = 10;
        this.getPageBySponsorAccountCode();
      } else if (val === "pendingApproval") {
        this.pendingApprovalPageNum = 1;
        this.pendingApprovalPageSize = 10;
        this.getPendingApprovalPage();
      } else if (val === "approved") {
        this.approvedPageNum = 1;
        this.approvedPageSize = 10;
        this.getApprovedPage();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.workbench-approval {
  /deep/ .el-collapse-item__header {
    height: 60px;
    line-height: 60px;
  }
  .item {
    font-size: 16px;
    line-height: 28px;
    margin-right: 29px;
    .el-badge__content.is-fixed {
      top: 2px;
      right: 5px;
    }
    i {
      width: 40px;
      font-size: 18px;
      color: #00a0e6;
      margin-right: 5px;
    }
  }
  .breadcrumb-box {
    border-bottom: 0 !important;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      /*padding-left: 20px!important;*/
      padding: 0 20px 0 0;
    }
    #tab-pendingApproval {
      /*margin: 0 20px 0 0;*/
    }
    .is-top:last-child {
      /*padding-left: 0;*/
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-main {
    height: 96%;
    /*padding: 10px 10px 0 10px;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    h4 {
      border-left: 3px solid #00a0e6;
      padding-left: 5px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      text-align: left;
    }
    .approval-main-top {
      height: 45%;
      .all-table-class .el-table td {
        padding: 3px 0;
      }
    }
    .approval-main-bottom {
      height: 45%;
      .all-table-class .el-table td {
        padding: 8px 0;
      }
    }
    .el-tabs__content {
      padding-bottom: 20px;
      height: 100%;
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
  /deep/ .el-tabs__item.is-active {
    background-color: #1362ff;
    color: #fff;
    border-radius: 3px;
  }
  /deep/ .breadcrumb-box {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #1362ff;
  }
}
</style>

<style lang="less" scoped>
.workbench-approval {
  /deep/ .el-collapse-item__header {
    height: 60px;
    line-height: 60px;
  }
  .item {
    font-size: 16px;
    line-height: 28px;
    margin-right: 29px;
    .el-badge__content.is-fixed {
      top: 2px;
      right: 5px;
    }
    i {
      width: 40px;
      font-size: 18px;
      color: #00a0e6;
      margin-right: 5px;
    }
  }
  .breadcrumb-box {
    border-bottom: 0 !important;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      /*padding-left: 20px!important;*/
      padding: 0 20px 0 0;
    }
    #tab-pendingApproval {
      /*margin: 0 20px 0 0;*/
    }
    .is-top:last-child {
      /*padding-left: 0;*/
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-main {
    height: 96%;
    /*padding: 10px 10px 0 10px;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    h4 {
      border-left: 3px solid #00a0e6;
      padding-left: 5px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      text-align: left;
    }
    .approval-main-top {
      height: 45%;
      .all-table-class .el-table td {
        padding: 3px 0;
      }
    }
    .approval-main-bottom {
      height: 45%;
      .all-table-class .el-table td {
        padding: 8px 0;
      }
    }
    .el-tabs__content {
      padding-bottom: 20px;
      height: 100%;
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
  /deep/ .el-tabs__item.is-active {
    background-color: #1362ff;
    color: #fff;
    border-radius: 3px;
  }
  /deep/ .breadcrumb-box {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #1362ff;
  }
}
/deep/ .el-step__description {
  margin-top: -8em ;
}
/deep/ .el-dialog__body{
  padding:50px 0 ;
  color: #1362FF ;
}
/deep/.el-step__head.is-success{
  color: #1362FF ;
  border-color: #1362FF ;
}
/deep/.el-step__title.is-success{
  color: #1362FF ;
}
/deep/.el-step__description.is-success{
  color:#1362FF ;
}
</style>



// WEBPACK FOOTER //
// src/view/PendingItems/ContractApproval/ContractApproval.vue